<template>
  <div id="candidatos-registra">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Proceso de seguimiento Scan
              </v-toolbar-title>
            </v-toolbar>
            <v-form>
              <v-container>
                <v-layout>
                  <v-flex>
                    <scan-data :id="id" :tipeView="tipeView"></scan-data>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import ScanData from "@/modules/captura/views/seguimiento/scan/ScanData.vue";

import axios from "axios";

export default {
  name: "scan-registra",
  components: {
    ScanData,
  },
  props: {},

  data: () => ({
    documentoId: "",
    id: "",
    tipeView: "",
  }),

  computed: {},
  mounted() {},
  created() {
    this.id = this.$route.params.id;
    this.tipeView = this.$route.params.tipeView;
    this.tab = this.$store.getters.subTabSelectedStored;
  },

  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
